import React from "react"

const Back = ({ name, title, cover }) => {
  return (
    <>
      <div className='back'>
        <div className='container text-center'>
          <h1>{title}</h1>
          <p>Gayrimenkul dünyasından en güncel bilgiler ve ilham verici içerikler</p>
        </div>
        <img src={cover} alt='' />
      </div>
    </>
  )
}

export default Back
